import { GetServerSideProps, NextPage } from 'next'
import { useCallback, useState } from 'react'
import { SEOHead } from '~/components/business/SEOHead'
import { GlobalRequest } from '~/components/global-request'
import { RankHeader } from '~/components/pages/rank/RankHeader'
import { RankList } from '~/components/pages/rank/RankList'
import { RankTab, RankTabProps } from '~/components/pages/rank/RankTab'
import { AI_CREATORS_TYPE } from '~/components/pages/rank/types'
import { MyContainer } from '~/components/ui/MyContainer'
import { RANK_PAGE_SIZE } from '~/configs'
import { GET_AI_SAME_STYLE_RANK } from '~/graphqls/gqls'
import {
  getAiSameStyleRank,
  getAiSameStyleRankVariables,
  getAiSameStyleRank_copyrightStatisticsModule_rankList_edges_node,
  QueryDateEnum,
} from '~/graphqls/types'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { Layout } from '~/layouts/default'
import { getGraphData, serverSideCatch } from '~/utils'

const RankSameStyle: NextPage<{
  rankData: getAiSameStyleRank_copyrightStatisticsModule_rankList_edges_node[]
}> = ({ rankData: _rankData }) => {
  const getDataAction = useImperativeQuery<
    getAiSameStyleRank,
    getAiSameStyleRankVariables
  >(GET_AI_SAME_STYLE_RANK)

  const [rankData, setRankData] = useState(_rankData)

  const tabData: RankTabProps[] = [
    {
      name: '7日',
      value: QueryDateEnum.SEVEN_DAYS,
    },
    {
      name: '30日',
      value: QueryDateEnum.THIRTY_DAYS,
    },
  ]

  const onTabChange = useCallback((item: RankTabProps) => {
    getDataAction({
      first: RANK_PAGE_SIZE,
      offset: 0,
      date: item.value as QueryDateEnum,
    }).then(res => {
      setRankData(
        getGraphData(res.data.copyrightStatisticsModule?.rankList?.edges || [])
      )
    })
  }, [])

  return (
    <Layout headerType="no-margin">
      <SEOHead title="同款榜-AI创作" />
      <RankHeader />

      <MyContainer>
        <div
          className="rounded-3xl py-4 px-12 -mt-[92px] mb-6"
          style={{
            background:
              'linear-gradient(0deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.04)), #141416',
          }}
        >
          <RankTab className="mb-6" data={tabData} onChange={onTabChange} />
          <RankList data={rankData} type={AI_CREATORS_TYPE.SAME_STYlE} />
        </div>
      </MyContainer>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  return await serverSideCatch(async () => {
    const { initialState, client } = await GlobalRequest(context)

    const res = await client.query<
      getAiSameStyleRank,
      getAiSameStyleRankVariables
    >({
      query: GET_AI_SAME_STYLE_RANK,
      fetchPolicy: 'no-cache',
      variables: {
        first: RANK_PAGE_SIZE,
        offset: 0,
        date: QueryDateEnum.SEVEN_DAYS,
      },
    })

    return {
      props: {
        initialState,
        rankData: getGraphData(
          res.data?.copyrightStatisticsModule?.rankList?.edges || []
        ),
      },
    }
  })
}

export default RankSameStyle
